import * as models from 'models/index';
import { children, darkenColor } from 'util/style-variables';
import { StyleSheet } from 'aphrodite/no-important';

export const style: any = (styles: models.base.IGenericObject) =>
  StyleSheet.create({
    fbPermissions: {
      textAlign: 'center',
      padding: '40px'
    },

    headline: {
      ...styles.fbErrorStyles.headline
    },

    description: {
      ...styles.fbErrorStyles.description
    },

    facebook_button: {
      fontSize: '16px',
      padding: '8px',
      width: '100%',
      ...styles.buttonStyles.default,
      minHeight: '40px',
      background: 'rgb(59, 89, 153)',
      margin: '10px auto',
      color: '#fff',

      [children('svg')]: {
        fill: '#fff',
        height: '20px',
        transform: 'translateY(3px)'
      },

      [children('> span')]: {
        marginRight: '15px'
      },

      ':hover': {
        background: darkenColor('rgb(59, 89, 153)'),
      },

      ':focus': {
        background: darkenColor('rgb(59, 89, 153)'),
      },
    }
  });
